import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalError = _resolveComponent("GlobalError")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_SidePanel = _resolveComponent("SidePanel")!
  const _component_Disclaimer = _resolveComponent("Disclaimer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["body", [
            _ctx.UtilityHelper.isOandaPath() ? 'oanda' : '',
            _ctx.isGbg ? 'gbg-active' : '',
            _ctx.isUploadDocumentStep ? 'document-upload' : '',
        ]])
  }, [
    _createElementVNode("div", {
      id: "app-content",
      class: _normalizeClass([
                _ctx.isOpenModal ? 'dark-background' : '',
                _ctx.isGbg ? 'gbg-active' : '',
                _ctx.isUploadDocumentStep ? 'document-upload' : '',
                _ctx.showLongDisclaimer ? 'long' : '',
            ])
    }, [
      _createVNode(_component_GlobalError),
      (!_ctx.isGbg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Logo),
            _createVNode(_component_ProgressBar)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }),
      _createVNode(_component_Loader),
      _createVNode(_component_SidePanel),
      _createVNode(_component_Disclaimer)
    ], 2)
  ], 2))
}